import { model } from "core/util";

import { SimpleCodeValue } from "../common";
import { UniqaLifeInvestmentFund } from "./UniqaLifeInvestmentFund";

export const UniqaLifeInvestmentStrategy = model.createModelLegacy("UniqaLifeInvestmentStrategy", (json) => ({
    insuranceTariff: SimpleCodeValue.fromServer(json.InsuranceTariff),
    investmentFunds: UniqaLifeInvestmentFund.fromServerList(json.InvestmentFunds),
}));
